import type { FamilyChild, SchoolYear } from "../types";

export const isDeceased = (child: FamilyChild): boolean => Boolean(child.deceasedAt);
export const isWithdrawn = (child: FamilyChild): boolean => Boolean(child.withdrawnAt);
export const isDeleted = (child: FamilyChild): boolean => Boolean(child.deletionRequestedAt);
export const isInactive = (child: FamilyChild): boolean => isDeceased(child) || isWithdrawn(child) || isDeleted(child);

export const sortFamilyChildren = (left: FamilyChild, right: FamilyChild): number => {
  const leftInactive = isInactive(left);
  const rightInactive = isInactive(right);
  if (leftInactive && !rightInactive) return 1;
  if (!leftInactive && rightInactive) return -1;
  if (isDeceased(left) && !isDeceased(right)) return 1;
  if (!isDeceased(left) && isDeceased(right)) return -1;
  if (isDeleted(left) && !isDeleted(right)) return 1;
  if (!isDeleted(left) && isDeleted(right)) return -1;
  return (left.lastName || "").localeCompare(right.lastName || "", "nl");
};

export const currentSchoolYearFee = (years: SchoolYear[]): number | null => {
  const today = new Date();
  const match = years.find((year) => {
    if (!year.startDate || !year.endDate) return false;
    const start = new Date(year.startDate);
    const end = new Date(year.endDate);
    return today >= start && today <= end;
  });
  const fee = match?.defaultMonthlyFee;
  if (fee == null) return null;
  const numeric = Number(fee);
  return Number.isFinite(numeric) ? numeric : null;
};
